var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card-text",
    [
      _c(
        "v-timeline",
        { attrs: { "align-top": "", dense: "" } },
        [
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _vm._v(
                      "Drag green controls to adjust character dimensions"
                    ),
                  ]),
                  _c(
                    "v-col",
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/day6-workflow/editor-green-rings.svg",
                          "max-width": "128",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _vm._v("Drag sliders to fine tune other sizes"),
                  ]),
                  _c(
                    "v-col",
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/day6-workflow/editor-sliders.svg",
                          "max-width": "128",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", { attrs: { cols: "6" } }, [
                    _vm._v(
                      "Double click the head, neck, body, legs, or feet to tune the body section further"
                    ),
                  ]),
                  _c(
                    "v-col",
                    [
                      _c("v-img", {
                        attrs: {
                          src: "/day6-workflow/tune-body-section.png",
                          "max-width": "128",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _vm._v("Change the "),
                    _c(
                      "a",
                      {
                        staticClass: "accent--text",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.$emit("show-info-tips")
                          },
                        },
                      },
                      [_vm._v("camera/view")]
                    ),
                    _vm._v(" for a better perspective"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v(_vm._s(_vm.mdiHuman))])],
                        1
                      ),
                      _vm._v("opens  "),
                      _c(
                        "a",
                        {
                          staticClass: "accent--text",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.$emit("show-info-pose")
                            },
                          },
                        },
                        [_vm._v("Character Pose")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c(
                    "v-col",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-4",
                          attrs: {
                            outlined: "",
                            fab: "",
                            small: "",
                            color: "accent",
                          },
                        },
                        [_c("v-icon", [_vm._v("download")])],
                        1
                      ),
                      _vm._v("downloads the character asset file"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _vm._v(
                      "Import the asset file into your favorite game engine or content editor and have a blast. See these "
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "accent--text",
                        attrs: {
                          href: "https://day6-docs.quickytools.com/guides/configure-unity-import.html",
                          target: "_blank",
                        },
                      },
                      [_vm._v("instructions")]
                    ),
                    _vm._v(" for setting up 1-click integration in Unity."),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-timeline-item",
            { attrs: { color: "accent", small: "" } },
            [
              _c(
                "v-row",
                { staticClass: "pt-1" },
                [
                  _c("v-col", [
                    _vm._v("What do you think? Share "),
                    _c(
                      "a",
                      {
                        staticClass: "accent--text",
                        attrs: {
                          href: _vm.day6Resource.feedbackSurveyUrl,
                          target: "_blank",
                        },
                      },
                      [_vm._v("your thoughts")]
                    ),
                    _vm._v(
                      " with us on how to speed up your character creation."
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }